import BlazeIndex from "../../pages/dashboard/third-party/blaze/BlazeIndex";
import BridgeIndex from "../../pages/dashboard/third-party/bridge/BridgeIndex";
import ThirdPartyControlPanel from "../../pages/dashboard/third-party/control-panel";
import PayazaIndex from "../../pages/dashboard/third-party/payaza/PayazaIndex";
import ZojapayIndex from "../../pages/dashboard/third-party/zojapay/ZojapayIndex";
import { ALL_ROUTES } from "../AllRoutes";

export const third_party_route_group = [
  {
    path: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_PAYAZA,
    element: PayazaIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_BLAZE,
    element: BlazeIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_BRIDGE,
    element: BridgeIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_ZOJAPAY,
    element: ZojapayIndex,
  },
  {
    path: ALL_ROUTES?.DASHBOARD_THIRD_PARTY_CONTROL_PANEL,
    element: ThirdPartyControlPanel,
  },
];
